export default "__VITE_ASSET__D4Kd1c_R__"